import { render, staticRenderFns } from "./GroceryStores.vue?vue&type=template&id=aad4bfb8&"
import script from "./GroceryStores.vue?vue&type=script&lang=js&"
export * from "./GroceryStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports